/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import AuthActions from 'auth/AuthActions';
import CenteredContainer from 'components/CenteredContainer';
import DeviceActions from 'actions/DeviceActions';
import EventTracking from 'lib/EventTracking';
import ParentalConsentOptionView from 'user/components/ParentalConsentOptionView';
import ParentalConsentOptionsView from 'user/components/ParentalConsentOptionsView';
import ToastActions from 'actions/ToastActions';
import View from 'components/View';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

const EVENT_SCREEN_NAME = 'vpc_flow';

type Props = {
  location: Object,
};

type State = {
  childId: Backbone$Id,
  childName: string,
  option: string,
};

class ParentalConsentPage extends React.Component<Props, State> {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static childContextTypes = {
    eventContextName: PropTypes.string,
    eventScreenName: PropTypes.string,
  };

  // This has to be here in order to get a CurrentUser
  static onEnter(
    nextState: RouterState,
    replaceWith: (location: LocationDescriptor) => void,
    callback: Function
  ) {
    const redirect = () => {
      ToastActions.showErrorToast('Your link has expired, please contact support for assistance.');
      replaceWith('/log_in');
      callback();
    };

    AuthActions.accessTokenSignIn(nextState.location.query.token)
      .then(() => DeviceActions.loadDevices().then(() => callback()))
      .catch(redirect);
  }

  constructor(props: Props) {
    super(props);
    const { query } = props.location;

    this.state = {
      childId: parseInt(query['child_id'], 10),
      childName: query['child_name'],
      option: '',
    };
  }

  getChildContext() {
    const { referrer } = this.props.location.query;

    return {
      eventContextName: referrer,
      eventScreenName: EVENT_SCREEN_NAME,
    };
  }

  componentDidMount() {
    EventTracking.view(EVENT_SCREEN_NAME, { uiContext: this.props.location.query.referrer });
  }

  setOption = (option: string) => {
    this.setState({ option });
  };

  proceed = () => {
    this.context.router.push('/setup');
  };

  renderBody = () => {
    const { childId, childName, option } = this.state;

    if (option) {
      return (
        <ParentalConsentOptionView
          childId={childId}
          option={option}
          setOption={this.setOption}
          onProceed={this.proceed}
        />
      );
    } else {
      return (
        <ParentalConsentOptionsView
          childName={childName}
          setOption={this.setOption}
          onProceed={this.proceed}
        />
      );
    }
  };

  render() {
    return (
      <div className="ParentalConsentPage">
        <CenteredContainer>
          <View>{this.renderBody()}</View>
        </CenteredContainer>
      </div>
    );
  }
}

export default ParentalConsentPage;
